import React, { useEffect, useState, useMemo, useDeferredValue } from "react";
import Button from "../../components/common/ui/Button.jsx";
import ExcelExport from "../../components/common/ui/Export/ExcelExport.jsx";
import { useDispatch, useSelector } from "react-redux";
import men from "../../assets/male.png";
import women from "../../assets/female.png";
import { masterActions, authActions } from "../../_store/index.js";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication.js";
import CustomLoader from "../../components/common/ui/Loader.jsx";
import { Link } from "react-router-dom";
import CommonModal from "../../components/common/ui/NotificationModal/CommonModal.js";
import Table from "../../components/common/table/Table.jsx";
import SearchTextInput from "../../components/common/ui/Inputs/SearchTextInput.jsx";
import { dashboardAction } from "../../_store/dashboard.slice.js";
import generateXlsx from "../../components/common/export/generateXlsx.js";
import { StoredProcedures } from "../../_helpers/enumerator.js";
import AddIcon from "../../assets/svg/btn_icons/create-btn-icon.svg";
import AdminDashboard from "./AdminDashboard.jsx";
import DashboardCard from "./DashboardCard.jsx";

function Dashboard() {
  const commonFacilityCode = useSelector(
    (state) => state.auth.commonFacilityCode
  );
  const user = useSelector((x) => x.auth.user);
  const [dashboard, setDashboard] = useState({
    facilityID: commonFacilityCode,
    CreatedBy: user?.ManagementUserID,
  });

  const isPageReloading = useSelector((state) => state.master?.isPageReload);
  const IsSuperAdmin = false;
  //  const IsSuperAdmin = user?.UserRoleID === 1;

  const [searchQuery, setSearchQuery] = useState("");
  const dispatch = useDispatch();
  const [errordetails, seterrordetails] = useState({
    pageNo: 1,
    rowCountPerPage: 10,
    SortBy: "",
  });

  const {
    getDashboardInfo,
    importInmateResponse,
    errorDetailsResponse,
    loading,
  } = useSelector((state) => state.dashboard);
  // const [activeTab, setactiveTab] = useState(commonFacilityCode == 0 ? "overviewTab" : "DashboardTab");
  const [activeTab, setactiveTab] = useState(commonFacilityCode == 0 ? "DashboardTab" : "DashboardTab");

  useEffect(() => {
    if (commonFacilityCode) {
      setDashboard((prev) => ({
        ...prev,
        facilityID: commonFacilityCode,
      }));
    }
    // setactiveTab(commonFacilityCode == 0 ? "overviewTab" : "DashboardTab");
    dispatch(masterActions.LoadFacilityDropDown({ facilityID: 0, activeStatus: 1 }));
  }, [commonFacilityCode]);


  useEffect(() => {
    // Insert Management User Activity Log
    if (commonFacilityCode === 0) return;
    dispatch(
      authActions?.ManagementUserActivityLog({
        ManagementUserID: user?.ManagementUserID,
        facilityID: commonFacilityCode,
        ProcedureName: StoredProcedures?.LoadDashBoardInmateStatics,
        UserAction: `Bind Dashboard Details`,
      })
    );
    dispatch(dashboardAction.GetDashboardInfo(commonFacilityCode));
  }, [
    commonFacilityCode,
    importInmateResponse?.IsSucceed > 0,
    isPageReloading,
  ]);

  useEffect(() => {
    if (Object.keys(importInmateResponse)?.length > 0) {
      switch (importInmateResponse?.IsSucceed) {
        case 1:
          showToastNotification(
            "Inmates Information Imported Successfully.",
            "success"
          );
          dispatch(dashboardAction.clearimportInmateResponse());
          break;
        case -1:
          showToastNotification("Please verify FTP file.", "error");
          dispatch(dashboardAction.clearimportInmateResponse());
          break;
        case -2:
          showToastNotification(
            "Please verify FTP facility information.",
            "error"
          );
          dispatch(dashboardAction.clearimportInmateResponse());
          break;
        case -3:
          showToastNotification(
            "Inmate Import type is set as None. Please select Webservice or FTP in Facility.",
            "error"
          );
          dispatch(dashboardAction.clearimportInmateResponse());
          break;
        case -4:
          showToastNotification(
            "Please verify Web Service facility information.",
            "error"
          );
          dispatch(dashboardAction.clearimportInmateResponse());
          break;
        case -6:
          showToastNotification("Operation Failed.", "error");
          dispatch(dashboardAction.clearimportInmateResponse());
          break;

        default:
          showToastNotification(
            "Error in CACTAS service, Try again later.",
            "error"
          );
          dispatch(dashboardAction.clearimportInmateResponse());
          break;
      }
    }
  }, [importInmateResponse]);

  const filteredData = useMemo(() => {
    // Check if errorDetailsResponse contains the necessary data
    const data = Array.isArray(errorDetailsResponse)
      ? errorDetailsResponse // If it's already an array, use it
      : errorDetailsResponse?.DataList || []; // If it's an object, look for the 'data' property or fallback to empty array

    // Now safely filter the array by checking all fields
    return data?.filter((item) => {
      // Convert the item to a string and check if any field includes the search query
      return Object?.values(item) // Get all values of the item object
        .some((value) =>
          value
            ? value
              ?.toString()
              .toLowerCase()
              .includes(searchQuery?.toLowerCase())
            : false
        );
    });
  }, [searchQuery, errorDetailsResponse]);

  const handleSearchChange = (e) => {
    const value = e.target.value.replace(/^\s+/, "");
    setSearchQuery(value);
  };

  const handleImportInmates = () => {
    dispatch(dashboardAction.clearimportInmateResponse());
    const facilityID = commonFacilityCode;
    const CreatedBy = user?.ManagementUserID;
    // Insert Management User Activity Log
    dispatch(
      authActions?.ManagementUserActivityLog({
        ManagementUserID: user?.ManagementUserID,
        facilityID: commonFacilityCode,
        ProcedureName: StoredProcedures?.LoadCactasService,
        UserAction: `Imported Inmate Details`,
      })
    );
    dispatch(dashboardAction.ImportInmate({ facilityID, CreatedBy }));
  };

  const handleInactiveInmatePhotoMerge = () => {
    //dispatch(dashboardAction.clearimportInmateResponse());
    const facilityID = commonFacilityCode;
    const CreatedBy = user?.ManagementUserID;
    // Insert Management User Activity Log
    dispatch(
      authActions?.ManagementUserActivityLog({
        ManagementUserID: user?.ManagementUserID,
        facilityID: commonFacilityCode,
        ProcedureName: StoredProcedures?.MoveInactiveInmatePhotoArchieve,
        UserAction: `Inactive Photo Merge`,
      })
    );


    dispatch(dashboardAction.MoveInactiveInmatePhotoArchieve({ facilityID, CreatedBy }))
      .unwrap()
      .then((result) => {
        if (result?.IsSucceed === 1) {
          showToastNotification(
            "Inactive Inmates Photos Moved Successfully.",
            "success"
          );
        } else {
          showToastNotification("Operation Failed.", "error");
        }
      })
      .catch((err) => {
        showToastNotification(err?.message || "Something went wrong", "error");
      });
  };
  /// get current data to set report title
  const today = new Date();
  const month = today?.getMonth() + 1;
  const year = today?.getFullYear();
  const date = today?.getDate();
  /// Excel download
  const handleClickExcel = () => {
    let title = "Inmate_Report";
    let generateExcelColumns = [
      "Inmate ID",
      "POD",
      "First Name",
      "Middle Name",
      "Last Name",
      "Gender",
      "DOB",
    ];

    // Map the account manager list to match the Excel format
    let error_List =
      errorDetailsResponse?.DataList?.map((obj) => ({
        Inmate_ID: obj.InmateResidentId || "-",
        POD: obj.PodCode || "-",
        First_Name: obj.FirstName || "-",
        Middle_Name: obj.MiddleName || "-",
        Last_Name: obj.LastName || "-",
        Gender: obj.Gender || "-",
        DOB: obj.DOB || "-",
      })) || {};
    try {
      // Generate the Excel file with the transformed data
      generateXlsx(
        error_List,
        generateExcelColumns,
        `Inmate_Report_${month + "-" + date + "-" + year}`
      );
    } catch (error) {
      // Handle any errors that occur during Excel generation
      showToastNotification("Error generating Excel file", "error");
    }
  };

  const Column = [
    {
      name: "Inmate ID",
      selector: (row) => row.InmateResidentId,
      sortable: true,
      center: true,
      key: "InmateResidentId",
      style: { textAlign: "left", justifyContent: "left" },
    },
    {
      name: "POD",
      selector: (row) => row.PodCode,
      sortable: true,
      center: true,
      key: "PodCode",
      style: { textAlign: "left", justifyContent: "left" },
    },
    {
      name: "First Name",
      selector: (row) => row.FirstName,
      sortable: true,
      center: true,
      key: "FirstName",
      style: { textAlign: "left", justifyContent: "left" },
    },
    {
      name: "Middle Name",
      selector: (row) => row.MiddleName,
      sortable: true,
      center: true,
      key: "MiddleName",
      style: { textAlign: "left", justifyContent: "left" },
    },
    {
      name: "Last Name",
      selector: (row) => row.LastName,
      sortable: true,
      center: true,
      key: "LastName",
      style: { textAlign: "left", justifyContent: "left" },
    },
    {
      name: "Gender",
      selector: (row) => row.Gender,
      sortable: true,
      center: true,
      key: "Gender",
      style: { textAlign: "left", justifyContent: "left" },
    },
    {
      name: "DOB",
      selector: (row) => row.DOB,
      sortable: true,
      center: true,
      key: "DOB",
      style: { textAlign: "left", justifyContent: "left" },
    },
  ];

  const handleErrorDetailsList = () => {
    setSearchQuery("");
    seterrordetails((prevState) => ({
      ...prevState,
      pageNo: 1,
      rowCountPerPage: 10,
    }));
    dispatch(dashboardAction.clearErrorResponse());
    const data = {
      ftpImportInmateFileID: getDashboardInfo?.FtpImportInmateFileID,
      sortBy: "",
      pageNo: 1,
      rowCountPerPage: 10,
    };
    dispatch(dashboardAction.GetDashboardError(data));
  };

  //Pagination
  const handlePageChange = (value) => {
    if (sorting) {
      sorting = false;
      return;
    }
    const updatederrordetails = { ...errordetails, pageNo: value };
    seterrordetails(updatederrordetails);
    const data = {
      ftpImportInmateFileID: getDashboardInfo?.FtpImportInmateFileID,
      sortBy: updatederrordetails?.SortBy,
      pageNo: updatederrordetails?.pageNo,
      rowCountPerPage: updatederrordetails?.rowCountPerPage,
    };
    dispatch(dashboardAction.GetDashboardError(data));
  };

  const handleRowPerPage = (value) => {
    const updatederrordetails = {
      ...errordetails,
      pageNo: 1,
      rowCountPerPage: value,
    };
    seterrordetails(updatederrordetails);
    const data = {
      ftpImportInmateFileID: getDashboardInfo?.FtpImportInmateFileID,
      sortBy: updatederrordetails?.SortBy,
      pageNo: updatederrordetails?.pageNo,
      rowCountPerPage: updatederrordetails?.rowCountPerPage,
    };
    dispatch(dashboardAction.GetDashboardError(data));
  };
  let sorting = false;
  const handleSort = (column, sortDirection) => {
    if (!column?.key) return;
    sorting = true;
    const search = { ...errordetails };
    const newSortOrder = search.SortBy?.includes(column.key)
      ? search.SortBy.endsWith("asc")
        ? "desc"
        : "asc"
      : "asc";
    search.SortBy = `${column.key} ${newSortOrder}`;
    seterrordetails(search);
    dispatch(
      dashboardAction.GetDashboardError({
        ftpImportInmateFileID: getDashboardInfo?.FtpImportInmateFileID,
        pageNo: errordetails?.pageNo,
        rowCountPerPage: errordetails?.rowCountPerPage,
        SortBy: `${column.key} ${newSortOrder}`,
      })
    );
  };

  if (loading) return <CustomLoader />;

  const dashboardInfo = () => {
    return (
      <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 me-3 w-100 mb-4 ">
        {IsSuperAdmin && <div className="overflow-auto">
          <ul
            className="nav nav-tabs tab-bg d-flex flex-nowrap overflow-auto"
            style={{ whiteSpace: "nowrap" }}
          >
            <li className="nav-item flex-shrink-0">
              <a
                href="#overviewTab"
                data-bs-toggle="tab"
                className={`nav-link ${activeTab === "overviewTab" ? "active" : "text-black"
                  }`}
                onClick={() => setactiveTab("overviewTab")}
              >
                <span className="font-size-15"><i className="fa fa-chart-line me-2"></i>OVERVIEW</span>
              </a>
            </li>
            <li className="nav-item flex-shrink-0">
              <a
                href="#DashboardTab"
                data-bs-toggle="tab"
                className={`nav-link ${activeTab === "DashboardTab"
                  ? "active"
                  : "text-black"
                  }`}
                onClick={() => setactiveTab("DashboardTab")}
              >
                <span className="font-size-15"><i className="fa fa-tachometer me-2"></i>DASHBOARD</span>
              </a>
            </li>
          </ul>
        </div>}
        <div className="dragicon-container">
        </div>
        <div className="tab-content panel rounded-0 m-0">
          <div
            className={`tab-pane fade ${activeTab === "overviewTab" ? "active show" : "text-black"}`}
            id="overviewTab"
          >
            {activeTab === "overviewTab" && <AdminDashboard />}
          </div>
          {activeTab === "DashboardTab" && (<div> {dashboardTab()} </div>)}
        </div>
      </div>
    )
  }

  const dashboardTab = () => {
    return (
      <>
        {commonFacilityCode !== 0 ? (
          <>
            <div className="row align-items-center">
              <div>
                <div className="d-flex flex-wrap justify-content-between align-items-center flex-wrap resp-space p-1">
                  <h2 className="form_title_uppercase text-color">
                    {IsSuperAdmin ? "" : "Dashboard"}
                  </h2>
                  {(user?.UserRoleID === 1 && commonFacilityCode !== 0) && (
                    <div className="d-flex flex-wrap gap-3 align-items-center">
                      <Button
                        variant="success"
                        className="me-2"
                        onClick={handleInactiveInmatePhotoMerge}
                        label="Sync/Archive Photos"
                        type="button"
                        status="btn-label"
                        title="Click to sync photo records. This will merge updates and archive inactive inmates, ensuring correct display in photo lists."
                      //imgsrc={AddIcon}
                      // icon="circle-plus"
                      />
                      <Button
                        variant="success"
                        className="me-2"
                        onClick={handleImportInmates}
                        label="Import Inmates"
                        type="button"
                        status="btn-label"
                        imgsrc={AddIcon}
                      // icon="circle-plus"
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/* <DashboardCard /> */}
            <div className="card border border-dark-grey mb-2 w-100">
              <div className="card-header">
                <h3 className="form_title_uppercase text-color">
                  INMATE Stats
                </h3>
              </div>
              <div className="card-body">
                <div className="align-items-center">
                  <div className="row mb-3">
                    <div className="col-lg-6">
                      <div className="dashboard-inmate card border-dark-grey  w-100">
                        <div className="card-header d-flex flex-wrap justify-content-around ">
                          <h5 className="col-6 text-center">Inmate</h5>
                          <h5 className="col-6 text-center">{getDashboardInfo?.TotalInmateActive}</h5>
                        </div>
                        <div className="card-body d-flex flex-wrap flex-column justify-content-around gap-3">
                          <div className=" d-flex flex-wrap justify-content-around">
                            <img src={men} height={"60px"} width={"60px"} />
                            <img src={women} height={"60px"} width={"60px"} />
                          </div>

                          <div className=" d-flex flex-wrap justify-content-around">
                            <h5 className="text-center customCardFooter w-auto card-footer col-6">
                              {getDashboardInfo?.TotalMaleInmateActive}
                            </h5>
                            <h5 className="text-center customCardFooter w-auto card-footer col-6">
                              {getDashboardInfo?.TotalFemaleInmateActive}
                            </h5>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="card dashboard-inmate border-dark-grey  w-100">
                        <div className="card-header d-flex ">
                          <h5 className="col-6 text-center">Logged In Today</h5>
                          <h5 className="col-6 text-center">{getDashboardInfo?.TotalInmateLoginToday}</h5>
                        </div>
                        <div className="card-body d-flex flex-wrap flex-column justify-content-around gap-3">
                          <div className="d-flex flex-wrap justify-content-around">
                            <img src={men} height={"60px"} width={"60px"} />
                            <img src={women} height={"60px"} width={"60px"} />
                          </div>

                          <div className=" d-flex flex-wrap justify-content-around">
                            <h5 className="mb-0 text-center customCardFooter w-auto card-footer col-6">
                              {getDashboardInfo?.TotalMaleLoginToday}
                            </h5>
                            <h5 className="mb-0 text-center customCardFooter w-auto card-footer col-6">
                              {getDashboardInfo?.TotalFemaleLoginToday}
                            </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-footer p-3">
                <div className="row  align-items-center">
                  <div className="col-lg-4 d-flex flex-wrap align-items-center mb-2 mt-2 ">
                    <h5 className="mb-0  d-flex flex-wrap flex-row align-items-center">
                      <i className="fa fa-sign-in mx-2 dashboard-icon"></i>
                      Total Logged In : {"  "}
                      {getDashboardInfo?.TotalLoginEverInmate === 0 ||
                        getDashboardInfo?.TotalFacilityInmate === 0
                        ? 0
                        : `${getDashboardInfo?.TotalLoginEverInmate}/${getDashboardInfo?.TotalFacilityInmate}`}
                      <div className=" mx-2" style={{ color: "#4a9a93 " }}>
                        (
                        {getDashboardInfo?.TotalLoginEverInmate === 0 ||
                          getDashboardInfo?.TotalFacilityInmate === 0
                          ? (0).toFixed(2)
                          : (
                            (getDashboardInfo?.TotalLoginEverInmate /
                              getDashboardInfo?.TotalFacilityInmate) *
                            100
                          ).toFixed(2)}
                        %)
                      </div>
                    </h5>
                  </div>
                  <div className="col-lg-4 d-flex flex-wrap align-items-center mb-2 mt-2">
                    <h5 className="mb-0  d-flex flex-wrap flex-row align-items-center">
                      <i className="fa fa-ban mx-2 me-2 dashboard-icon"></i>Locked Inmates :{" "}
                      {"  "}
                      {getDashboardInfo?.TotalInmateLoginDisable === 0 ||
                        getDashboardInfo?.TotalInmateActive === 0
                        ? 0
                        : `${getDashboardInfo?.TotalInmateLoginDisable}/${getDashboardInfo?.TotalInmateActive}`}
                      <div className=" mx-2" style={{ color: "#4a9a93 " }}>
                        (
                        {getDashboardInfo?.TotalInmateLoginDisable === 0 ||
                          getDashboardInfo?.TotalInmateActive === 0
                          ? (0).toFixed(2)
                          : (
                            (getDashboardInfo?.TotalInmateLoginDisable /
                              getDashboardInfo?.TotalInmateActive) *
                            100
                          ).toFixed(2)}
                        %)
                      </div>
                    </h5>
                  </div>
                  <div className="col-lg-4 d-flex flex-wrap align-items-center mb-2 mt-2">
                    <i className="fa fa-star mx-2 me-2 dashboard-icon"></i>
                    <h5 className="mb-0  d-flex flex-wrap flex-row align-items-center">
                      Kiosk in Active : {"  "}
                      {getDashboardInfo?.TotalNoOfActiveKiosks === 0 ||
                        getDashboardInfo?.TotalNoOfKiosks === 0
                        ? 0
                        : `${getDashboardInfo?.TotalNoOfActiveKiosks}/${getDashboardInfo?.TotalNoOfKiosks}`}
                      <div className=" mx-2" style={{ color: "#4a9a93 " }}>
                        (
                        {getDashboardInfo?.TotalNoOfActiveKiosks === 0 ||
                          getDashboardInfo?.TotalNoOfKiosks === 0
                          ? (0).toFixed(2)
                          : (
                            (getDashboardInfo?.TotalNoOfActiveKiosks /
                              getDashboardInfo?.TotalNoOfKiosks) *
                            100
                          ).toFixed(2)}
                        %)
                      </div>
                    </h5>
                  </div>
                </div>
              </div>
            </div>
            <div className="card  mt-3 border border-dark-grey  w-100">
              <div className="card-header d-flex flex-wrap">
                <h3 className="form_title_uppercase text-color m-1 ">
                  IMPORTED REPORT
                </h3>
              </div>
              <div className="">
                <div className="m-1 row border-bottom-0 ">
                  {[
                    {
                      label: "Facility",
                      value: getDashboardInfo?.FacilityName,
                    },
                    {
                      label: "Last Imported",
                      value:
                        getDashboardInfo?.LastInmateImportDateTime === ""
                          ? "-"
                          : getDashboardInfo?.LastInmateImportDateTime,
                    },
                    {
                      label: "Processed",
                      value: getDashboardInfo?.TotalInmateInExcelFile,
                    },
                    {
                      label: "Created",
                      value: getDashboardInfo?.TotalNewInmate,
                    },
                    {
                      label: "Re-Entry",
                      value: getDashboardInfo?.TotalInmateUpdate,
                    },
                    {
                      label: "Duplicates",
                      value: getDashboardInfo?.TotalDuplicateInmateInFile,
                    },
                    {
                      label:
                        getDashboardInfo?.TotalErrorInmateInFile > 0 ? (
                          <Link
                            className="text-danger fw-bold"
                            data-bs-toggle="modal"
                            data-bs-target="#dashboard-error-modal"
                            onClick={() => handleErrorDetailsList()}
                          >
                            <span className="label-red"> Error:</span>
                          </Link>
                        ) : (
                          <div className="fw-bold">Error:</div>
                        ),
                      value: getDashboardInfo?.TotalErrorInmateInFile,
                    },
                  ].map((item, index) => (
                    <div
                      key={index}
                      className="col-sm-12 col-md-6 col-lg-6 col-xl-4 "
                    >
                      <div className="user-information d-flex align-items-center">
                        <div className="fs-5 p-2  value-info fw-bold">
                          {item.label}
                        </div>
                        <div className="p-1">:</div>
                        <div className="fs-5 p-2 text-start ">
                          {item.value || "0"}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                <CommonModal
                  modalId="dashboard-error-modal"
                  title="Error Details"
                  loader={errorDetailsResponse?.loading}
                  bodyContent={
                    <div>
                      <div className="d-flex flex-wrap justify-content-between align-items-center mb-4">
                        <div className="col-md-4 flex-start form-group">
                          <SearchTextInput
                            name="Search"
                            value={searchQuery}
                            handleChange={handleSearchChange}
                            placeholder="Search"
                            maxLength={50}
                          />
                        </div>
                        <div className="mt-3 flex-end form-group">
                          <ExcelExport
                            variant="soft-gray"
                            handleExcelExport={handleClickExcel}
                          />
                        </div>
                      </div>
                      <Table
                        columns={Column}
                        data={filteredData}
                        pagination
                        onChangePage={(e) => handlePageChange(e)}
                        onChangeRowsPerPage={(e) => handleRowPerPage(e)}
                        totalRowCount={filteredData?.length}
                        currentPage={errordetails?.pageNo}
                        paginationPerPage={errordetails?.rowCountPerPage}
                        onSort={handleSort}
                        serverSideSort
                        sortColumn={errordetails?.SortBy?.split(" ")[0]}
                        sortDirection={errordetails?.SortBy?.split(" ")[1]}
                      />
                    </div>
                  }
                  footerContent={
                    <button
                      className="btn button-primary"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>
                  }
                />
              </div>
            </div>
          </>
        ) : (
          <h4 className="facility-card">
            Select a Facility Code from the list
          </h4>
        )}
      </>
    )
  }

  return (
    <div>
      {dashboardInfo()}
    </div>
  );
}

export default React.memo(Dashboard);
